import React, { FC } from 'react';

interface IHome {
  className: string;
}
const Home: FC<IHome> = (props) => (
  <svg
    {...props}
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_13751_590)">
      <path
        opacity="0.4"
        d="M9.33329 12.8775V10.2222C9.33329 10.1043 9.28647 9.99127 9.20312 9.90792C9.11977 9.82457 9.00672 9.77774 8.88885 9.77774H7.11107C6.9932 9.77774 6.88015 9.82457 6.7968 9.90792C6.71345 9.99127 6.66663 10.1043 6.66663 10.2222V12.8808C6.66663 12.9983 6.62011 13.111 6.53724 13.1943C6.45437 13.2776 6.34189 13.3247 6.2244 13.3252L3.11107 13.3333C2.9932 13.3333 2.88015 13.2865 2.7968 13.2031C2.71345 13.1198 2.66663 13.0067 2.66663 12.8889V8.33497L7.78857 4.11691C7.84877 4.06839 7.92375 4.04193 8.00107 4.04193C8.07839 4.04193 8.15337 4.06839 8.21357 4.11691L13.3333 8.3333V12.8889C13.3333 13.0067 13.2865 13.1198 13.2031 13.2031C13.1198 13.2865 13.0067 13.3333 12.8888 13.3333L9.77774 13.3247C9.71914 13.3247 9.66112 13.3131 9.60701 13.2906C9.55291 13.2681 9.50379 13.2351 9.46248 13.1935C9.42117 13.152 9.38849 13.1026 9.36632 13.0484C9.34415 12.9942 9.33293 12.9361 9.33329 12.8775Z"
        fill="#213F7D"
      />
      <path
        d="M15.9255 7.45416L15.2172 8.31528C15.1894 8.34913 15.1552 8.37717 15.1166 8.3978C15.0779 8.41843 15.0356 8.43124 14.992 8.4355C14.9484 8.43975 14.9044 8.43537 14.8625 8.42261C14.8206 8.40985 14.7816 8.38895 14.7478 8.36111L8.21362 2.97805C8.15342 2.92953 8.07843 2.90307 8.00112 2.90307C7.9238 2.90307 7.84882 2.92953 7.78862 2.97805L1.25475 8.36111C1.18646 8.41724 1.09866 8.44395 1.01068 8.43536C0.922692 8.42676 0.841724 8.38357 0.785587 8.31528L0.0772555 7.45416C0.020991 7.38601 -0.00590471 7.2983 0.0024817 7.21032C0.0108681 7.12234 0.0538501 7.04129 0.121978 6.985L7.15251 1.19444C7.39117 0.998046 7.69065 0.890667 7.99973 0.890667C8.30881 0.890667 8.60829 0.998046 8.84695 1.19444L11.3333 3.23916V1.22222C11.3333 1.13381 11.3684 1.04903 11.431 0.986517C11.4935 0.924004 11.5783 0.888885 11.6667 0.888885H13.2222C13.3106 0.888885 13.3954 0.924004 13.4579 0.986517C13.5204 1.04903 13.5555 1.13381 13.5555 1.22222V5.06972L15.8778 6.98389C15.9119 7.01156 15.9402 7.0457 15.9611 7.08434C15.9819 7.12299 15.995 7.16539 15.9994 7.20909C16.0039 7.25279 15.9996 7.29694 15.9869 7.339C15.9743 7.38106 15.9534 7.4202 15.9255 7.45416Z"
        fill="#213F7D"
      />
    </g>
    <defs>
      <clipPath id="clip0_13751_590">
        <rect width="16" height="14.2222" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Home;
